import React, {useEffect, useRef, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormInputs from './FormInputs'
import useFormContext from "../hooks/useFormContext"
import {translate} from "../i18n";
import {useNavigate} from "react-router-dom";
import {addFiles, removeFile, resetForm} from "../store/reducers/registrationSlice";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import {editUserType, resetUserType} from "../store/reducers/userTypeSlice";
import {endpoints} from "../servics/apiEndpoints";

const Form = () => {
    const dispatch = useDispatch();
    const {
        userType,
    } = useSelector(state => state.userType);
    const language_code = useSelector(state => state.lang);
    const actualCountry = useSelector((state) => state.country.country);
    const countryCode = actualCountry && actualCountry.value
        ? actualCountry.value.toLowerCase()
        : 'tg';

    const {
        page,
        setPage,
        data,
        title,
        canSubmit,
        disablePrev,
        disableNext,
        prevHide,
        nextHide,
        submitHide,
        validateStep,
        importExportFiles,
        powerOfAttorneyFiles,
    } = useFormContext()

    const handlePrev = () => setPage(prev => prev - 1)

    const handleNext = () => {
        const ok = validateStep(page);
        if (ok) {
            setPage(prev => prev + 1);
        }
    };

    const handleSubmit = e => {
        e.preventDefault()
        console.log(JSON.stringify(data))
    }


    // Reused methods from registrationForm.jsx

    useEffect(() => {
        dispatch(editUserType('hero'));
        // console.log("The actual userType:", userType);
    }, []);

    useEffect(() => {
        dispatch(editUserType('hero'));
        // console.log("Language code in forms:", language_code);
        // console.log("Actual countrycode:", countryCode);
        // console.log("Actual country in forms:", actualCountry);
    }, [actualCountry]);

    const navigate = useNavigate();
    const {
        files,
        heroFormFields
    } = useSelector(state => state.registration);

    const {
        country
    } = useSelector(state => state.country.country);

    // 🔽 Get the full registration state
    const registration = useSelector(state => state.registration);

    // 🔽 Dynamically select the correct form fields based on user type
    let formFields = registration.heroFormFields;


    const fileInputRef = useRef(null);
    const [feedback, setFeedback] = useState({ message: '', type: '' });

    const handleFileChange = (e) => {
        const selected = Array.from(e.target.files);
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
        const validFiles = selected.filter(file => allowedTypes.includes(file.type));

        if (validFiles.length !== selected.length) {
            alert("Seuls les fichiers .pdf, .jpg, .jpeg, .png sont autorisés.");
        }

        dispatch(addFiles(validFiles));
    };

    const handleRemoveFile = (fileName) => {
        dispatch(removeFile(fileName));
        if (files.length === 1 && fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const buildFormData = (data, importExportFiles, powerOfAttorneyFiles) => {
        const formData = new FormData();

        // Append JSON as 'requestDto'
        formData.append(
            "requestDto",
            new Blob([JSON.stringify(data)], { type: "application/json" })
        );

        // Append import/export proof files
        importExportFiles.forEach(file => {
            formData.append("importExportFiles", file);
        });

        // Append power of attorney files
        powerOfAttorneyFiles.forEach(file => {
            formData.append("powerOfAttorneyFiles", file);
        });

        return formData;
    };


    const onFormSubmit = async (e) => {
        e.preventDefault();

        let endpoint = null;
        if (userType === "hero") {
            endpoint = endpoints.hero;
        } else if (userType === "company") {
            endpoint = endpoints.company;
        } else if (userType === "nonCompany") {
            endpoint = endpoints.nonCompany;
        } else {
            toast.error("Veuillez sélectionner un type de compte.");
            return;
        }

        try {
            let response;
            if (userType === "company" || userType === "hero") {
                const formData = buildFormData(data, importExportFiles, powerOfAttorneyFiles);

                console.log("Form formData sent to backend:", data);

                response = await axios.post(endpoint, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
            } else {
                response = await axios.post(endpoint, data, {
                    headers: { "Content-Type": "application/json" },
                });
            }

            if (response.status === 201 || response.status === 200) {
                toast.success("Préinscription effectuée avec succès ! Consultez vos mails pour poursuivre");
                dispatch(resetForm());
                dispatch(resetUserType());
            } else {
                toast.error("Vos données sont incorrectes.");
            }
        } catch (error) {
            if (error.response) {
                const backendError = error.response.data;

                // on essaie différents champs possibles
                const errorMessage = backendError.detail
                    || backendError.errorMessage
                    || backendError.title
                    || "Une erreur est survenue côté serveur.";

                console.error("Erreur backend:", backendError);
                toast.error(errorMessage);

            } else if (error.request) {
                console.error("Aucune réponse du serveur:", error.request);
                toast.error("Le serveur ne répond pas. Vérifiez votre connexion.");
            } else {
                console.error("Erreur lors de la configuration de la requête:", error.message);
                toast.error("Erreur interne du client.");
            }
        }

    };

    useEffect(() => {
        if (feedback.message) {
            const timer = setTimeout(() => setFeedback({ message: '', type: '' }), 5000);
            return () => clearTimeout(timer);
        }
    }, [feedback]);

    const content = (
        <div>
            <ToastContainer position="top-center" autoClose={5000} />
            <form className="form flex-col" onSubmit={onFormSubmit}>
                <header className="form-header">
                    <h5>{translate('signup', language_code.lang)[title[page]]}</h5>

                    <div className="button-container">
                        <button type="button" className={`button ${prevHide}`} onClick={handlePrev} disabled={disablePrev}>{translate('button', language_code.lang).back_step_button}</button>

                        <button type="button" className={`button ${nextHide}`} onClick={handleNext} disabled={disableNext}>{translate('button', language_code.lang).next_step_button}</button>

                        <button type="submit" className={`button ${submitHide}`} onClick={onFormSubmit} disabled={!canSubmit} >{translate('button', language_code.lang).register_button}</button>
                    </div>
                </header>
                <FormInputs />
            </form>
        </div>
    )

    return content
}
export default Form